import Navigation from '@/pages/home/components/Navigation';
import StyleGuideHero from './components/StyleGuideHero';
import StyleTips from './components/StyleTips';
import LookbookGrid from './components/LookbookGrid';
import StyleCTA from './components/StyleCTA';
import Footer from '@/components/feature/Footer';

export default function StyleGuidePage() {
  return (
    <main className="min-h-screen font-sans">
      <Navigation />
      <StyleGuideHero />
      <StyleTips />
      <LookbookGrid />
      <StyleCTA />
      <Footer />
    </main>
  );
}
